var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "zoho-forward-settings" }, [
    _c("div", { staticClass: "mode-card" }, [
      _c(
        "div",
        { staticClass: "title" },
        [
          _c(
            "div",
            { staticClass: "title-content" },
            [
              _c("ZohoIcon", { staticClass: "zoho-icon" }),
              _vm._v(" "),
              _c("div", [
                _c("div", { staticClass: "title-text" }, [
                  _vm._v(_vm._s(_vm.$t("message.autoTransfer"))),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "subtitle" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t("message.autoTransferDescription")) +
                      "\n                    "
                  ),
                ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("a-switch", {
            staticClass: "md-warning ml-3",
            attrs: {
              "checked-children": "✔",
              "un-checked-children": "✖",
              checked: _vm.isZohoForwardEnabled(),
            },
            on: { change: _vm.toggleZohoForward },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }